import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { FadeUp, RevealLines } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FlameInitial } from "../components/FlameInitial";
import { CornerWebs } from "../components/CornerWebs";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { EmailSignup } from "../components/EmailSignup";
import {
  KICKSTARTER_BODY, KICKSTARTER_BODY_2,
} from "../lib/content";

export default function Support() {
  return (
    <>
      <Seo
        title="Support Tattooed Abroad | Join the Journey"
        description="Discover ways to support Tattooed Abroad, an upcoming tattoo and travel documentary series. Follow the project, share it, and help our community grow."
      />
      <section className="relative overflow-hidden bg-ink pt-20 pb-14 md:pt-24 md:pb-16">
        <div className="pointer-events-none absolute left-1/2 top-1/2 z-0 h-[560px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame opacity-[0.16] blur-[160px]" />
        <div className="pointer-events-none absolute -right-16 top-1/3 z-0 h-[380px] w-[380px] rounded-full bg-crimson opacity-[0.12] blur-[150px]" />
        <div className="pointer-events-none absolute -left-16 bottom-0 z-0 h-[340px] w-[340px] rounded-full bg-ember opacity-[0.10] blur-[150px]" />
        <CornerWebs />

        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
          <FadeUp>
            <div className="mx-auto mb-6 inline-flex items-center gap-3 border border-flame/50 bg-ink/60 px-5 py-2.5">
              <Clock size={15} className="text-flame" />
              <span className="font-gothic text-xs uppercase tracking-[0.3em] text-flame">Campaign Coming Soon</span>
            </div>
          </FadeUp>

          <h1 className="font-display text-5xl font-light leading-[1.02] tracking-tight text-white md:text-7xl">
            <RevealLines
              lines={[
                <><FlameInitial letter="H" size="0.9em" className="mr-[0.03em] translate-y-[5px] scale-x-[1.12]" />elp us make</>,
                <>
                  <span
                    style={{
                      backgroundImage: "linear-gradient(90deg, #FFD700 0%, #FF7A1A 50%, #E2341E 100%)",
                      WebkitBackgroundClip: "text",
                      backgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    Season One.
                  </span>
                </>,
              ]}
            />
          </h1>

          <FadeUp delay={0.3}>
            <p className="mx-auto mt-6 max-w-2xl font-body text-lg leading-relaxed text-white/65">{KICKSTARTER_BODY}</p>
            <p className="mx-auto mt-4 max-w-2xl font-body text-base leading-relaxed text-white/50">{KICKSTARTER_BODY_2}</p>
          </FadeUp>

          <FadeUp delay={0.45}>
            <button
              disabled
              data-testid="kickstarter-coming-soon"
              className="mt-8 cursor-not-allowed border border-white/20 bg-white/5 px-10 py-4 font-body text-xs uppercase tracking-[0.25em] text-white/40"
            >
              Kickstarter — Coming Soon
            </button>
          </FadeUp>

          <FadeUp delay={0.55}>
            <p className="mt-10 font-body text-sm text-white/55">Be first to know when the Kickstarter launches.</p>
            <div className="mx-auto mt-5 max-w-xl">
              <EmailSignup source="support" />
            </div>
          </FadeUp>
        </div>
      </section>

      <EditorialMarquee gap="mt-0" />
    </>
  );
}
